import {Model} from "@/store/models/model";
import axios from "@/store/vue-axios";

export class VserverBackups extends Model {

  static entity = 'vserver_backups'
  static primaryKey = 'id'
  static apiEntity = 'backups'

  static fields() {
    return {
      id: this.attr(null),
      vserver_id: this.attr(null),
      title: this.attr(null),
      path: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      actions: this.attr(true)

    }
  }
}

export default VserverBackups



// WEBPACK FOOTER //
// ./src/store/models/vserver/vserver_backups.js